module.exports = __webpack_public_path__ + "static/media/seadek.79a8e62a.jpg";